<template>
  <div class="chosedialog">
    <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" append-to-body>
      <div class="h-rowIn">
        <div class="h-rowBox">
          <div class="h-rowCon yxline">
            <div class="h-formbLine" style="margin-bottom: 1px;">
              <el-form :model="package" label-position="right" :inline="true" label-width="120" class="demo-ruleForm h-formbLine h-formbLine1">
                <!--                                <el-button @click="addPackage()" size="mini" type="text" style="float:right;font-size:20px;margin-right: -5px"icon="el-icon-circle-plus" circle></el-button>-->
                <!--                                    <el-button style="font-size:20px;color:crimson;float:right;margin-right: -5px" @click="deletePackage(index)" v-if="index != 0" type="text" size="mini" icon="el-icon-remove" circle></el-button>-->
                <el-form-item label="套餐描述" style="width: 45%;">
                  <el-select v-model="package.packageCode" :v="package.packageCode" placeholder="请选择" filterable :filter-method="showPackageList" :clearable="true" @change="getPackageDetail(package.packageCode)">
                    <el-option v-for="(item) in package.packageAllList" :key="item.packageCode" :label="item.packageName" :value="item.packageCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="链群" style="width: 45%;">
                  <el-input clearable disabled v-model="package.lianqunName"></el-input>
                </el-form-item>
                <el-form-item label="场景" style="width: 45%;">
                  <el-input clearable disabled v-model="package.sceneName"></el-input>
                </el-form-item>
                <!--                                    <el-form-item label="套餐数量" v-if="DetailFlag" style="width: 55%;">
                                    <el-input clearable type="number" @change="getNum(index)" v-model="package.num" oninput="value=value.replace(/\D|^0/g,'')"></el-input>
                                </el-form-item>-->
                <el-form-item label="套餐金额" style="width: 45%;">
                  <el-input clearable disabled v-model="package.packagePrice"></el-input>
                </el-form-item>
                <el-form-item label="套餐数量" style="width: 45%;" v-if="orderType=='zh'">
                  <el-input clearable oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" v-model="package.packageNum"></el-input>
                </el-form-item>
                <!--<el-table
                                            size="mini"
                                            ref="multipleTable"
                                            :data="package.bomDetailList"
                                            :border="true"
                                            tooltip-effect="dark"
                                            v-if="DetailFlag"
                                            style="width: 100%">
                                        <el-table-column
                                                prop="prodcode"
                                                label="产品编码"
                                                style="width: 25%"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="promodel"
                                                label="产品型号"
                                                style="width: 25%"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="num"
                                                label="数量"
                                                style="width: 25%"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="proPrice"
                                                label="单价"
                                                style="width: 25%"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                    </el-table>-->
              </el-form>
              <el-row style="display: flex;justify-content: center;margin: 10px 0;">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitPackage()">确认提交</el-button>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from '../../api/SystemService'
export default {
  components: {},
  data () {
    return {
      package: {
        id: null,
        lianqunCode: null,
        lianqunName: null,
        sceneCode: null,
        sceneName: null,
        childSceneCode: null,
        childSceneName: null,
        packageCode: null,
        packageName: null,
        packagePrice: null,
        packageNum: null,
        num: 1,
        shuilv: null,
        bomDetailList: [],
        packageAllList: [],
        isWhole: 0,
        companycode: null,
        packageTotalPrice: 0,
      },
      q: {
        lianqunCode: null,
        sceneCode: null,
        packageCode: null,
        packagePrice: null,
      },
      sceneList: [],
      showTj: false,
    }
  },
  created () {
    this.showTj = false;
    this.showPackageList();
  },
  methods: {
    //获取场景信息
    getSceneList () {
      this.q.lianqunCode = this.package.lianqunCode;
      this.q.sceneCode = this.package.sceneCode;
      ss.bom.getSceneList(this.q).then(rd => {
        this.sceneList = rd.msg;
      });
      ss.bom.getPackageByLq(this.q).then(rd => {
        this.package.packageAllList = rd.msg;
      });
    },
    //获取场景信息
    getPackageList () {
      var data = {};
      data.lianqunCode = this.package.lianqunCode;
      data.sceneCode = this.package.sceneCode;
      ss.bom.getPackageList(data).then(rd => {
        this.package.packageAllList = rd.msg;
      });
    },
    //添加套餐
    addPackage () {
      this.packageList.push(
        {
          id: null,
          lianqunCode: null,
          lianqunName: null,
          sceneCode: null,
          sceneName: null,
          packageCode: null,
          packageName: null,
          packagePrice: null,
          num: 1,
          shuilv: null,
          bomDetailList: [],
          packageAllList: [],
          isWhole: 0,
        }
      )
    },
    //根据选择的套餐,获取对应产品信息
    getPackageDetail (code) {
      var searchData = {};
      this.q.packageCode = this.package.packageCode;
      searchData.packageCode = this.q.packageCode;
      var data = this.package
      //获取对应套餐金额
      for (var i = 0; i < data.packageAllList.length; i++) {
        var tc = data.packageAllList[i];
        if (tc.packageCode == this.q.packageCode) {
          console.log("shuilv", tc);
          this.q.packagePrice = tc.packagePrice;
          this.package.packagePrice = tc.packagePrice;
          this.package.id = tc.id;
          this.package.shuilv = tc.shuilv;
          this.package.isWhole = tc.isWhole;
          this.package.lianqunCode = tc.lianqunCode;
          this.package.lianqunName = tc.lianqunName;
          this.package.sceneCode = tc.sceneCode;
          this.package.sceneName = tc.sceneName;
          this.package.childSceneCode = tc.childSceneCode;
          this.package.childSceneName = tc.childSceneName;
          this.package.packageName = tc.packageName;
          this.package.companycode = tc.companycode;
          this.package.packageTotalPrice = tc.packagePrice;
          this.package.packageNum = 1
        }
      }
      ss.bom.getPackageDetail(searchData).then(rd => {
        if (rd.f) {
          this.package.bomDetailList = rd.msg;
          this.showTj = true;
        } else {
          this.$msg.msge(rd.msg)
        }

      });
    },
    //批量修改对应表格中的数量信息
    getNum (index) {
      var list = [];
      list = this.package.bomDetailList;
      for (var i = 0; i < list.length; i++) {
        list[i].num = list[i].accumNum * this.package.num
      }
    },
    //提交套餐信息
    submitPackage () {
      if (this.showTj) {
        if (this.orderType == 'zh' && !this.package.packageNum) {
          this.$message.error('请输入套餐数量！');
          return false;
        }
        this.$emit('choseObj', this.package)
      }
    },
    showPackageList (value) {
      var data = {
        agentCode: null,
        packageName: null,
        companycode: null,
      }
      data.agentCode = this.AgentCode;
      data.packageName = value;
      data.companycode = this.Companycode;
      ss.bom.selectPackageList(data).then(rd => {
        this.package.packageAllList = rd.obj;
        console.log("`12`12`121", this.package.packageAllList)
      });
    },
  },
  computed: {
    DetailFlag: function () {
      return this.detailFlag;
    },
    AgentCode: function () {
      return this.agentCode;
    },
    Companycode: function () {
      return this.companycode;
    }
  },
  props: {
    detailFlag: {
      type: Boolean,
    },
    agentCode: {
      type: String,
    },
    companycode: {
      type: String,
    },
    orderType: {
      type: String,
    },
  }
}
</script>
<style>
.addPackage {
  width: 100%;
  padding: 10px;
  /* display:flex; */
}
.addPackage .el-form-item {
  width: 45% !important;
}
.addPackage .el-form-item /deep/ .el-form-item__content {
  width: 115px;
}
.xuanzewuliao .el-dialog__header {
  padding-top: 20px;
  padding-left: 20px;
}
.xuanzewuliao .el-dialog__body {
  padding: 20px;
}
.xuanzewuliao .el-table tbody td .cell {
  padding: 0.1rem 0.1rem !important;
}
.xuanzewuliao .h-formbLine .el-form-item__label {
  width: 39%;
}
.xuanzewuliao .h-formbLine .el-form-item__content {
  width: 61%;
}
.xuanzewuliao .yxline .h-formbLine .el-form-item__content {
  width: 61%;
}
.xuanzewuliao .yxline {
  padding-top: 0;
}
.xuanzewuliao .h-pagination {
  padding-top: 0rem;
  padding-bottom: 0rem;
}
.xuanzewuliao .h-rowCon {
  padding-bottom: 0rem;
}
.w-tongyi {
  padding: 0.1rem 0.25rem;
}
</style>
